export const settingsDefault = {
  showRating: false,
  ratingBg: '#F27321',
  showBtn: true,
  btnTextColor: '#000000',
  btnHoverTextColor: '#000000',
  btnHoverBgColor: '#FFFFFF',
  btnBgColor: '#FFFFFF',
  borderRadius: '0',
  borderColor: '#000000',
  addedCartText: 'Added to cart',
  addCartText: 'Add to cart',
  showSelectBox: true,
  selectBorderColor: '#d1d1d1',
  selectColor: '#000000',
  soldOutText: 'Sold Out',
  soldOutTextColor: '#DE9356',
  soldOutBgColor: '#FFFFFF',
  soldOutPosition: 'top-right',
  titlePorition: 'flex-start',
  bgColor: '#FFFFFF',
  TitleColor: '#000000',
  bgImgColor: '#f17320',
  productTitleColor: '#000000',
  priceColor: '#D6946F',
  originalPriceColor: '#B1B1B1',
  showOptionBox: true,
  showAddToCartBtn: true,
  heightDesktopImage: '236',
  widthDesktopImage: '236',
  heightMobileImage: '236',
  widthMobileImage: '236'
};
